/* eslint-disable */
document.addEventListener('DOMContentLoaded', function () {
  const selects = document.querySelectorAll('.custom-select-wrapper');
  const form = document.querySelector('.filter__custom-select');

  function closeDropdown(select) {
    select.setAttribute('aria-expanded', 'false');
    select.classList.remove('open');
    select.querySelector('.custom-options').style.display = 'none';
  }

  function closeAllDropdowns() {
    selects.forEach(wrapper => {
      const select = wrapper.querySelector('.custom-select');
      if (select.classList.contains('open')) {
        closeDropdown(select);
      }
    });
  }

  document.addEventListener('click', function (e) {
    e.stopPropagation();
    closeAllDropdowns();
  });

  selects.forEach(selectWrapper => {
    const select = selectWrapper.querySelector('.custom-select');
    const trigger = selectWrapper.querySelector('.custom-select-trigger');
    const options = selectWrapper.querySelectorAll('.custom-option');
    const selectedOption = selectWrapper.querySelector('.custom-select-trigger span');
    const hiddenInput = selectWrapper.querySelector('.hidden-select');

    let currentFocus = -1;

    select.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleDropdown(select);
    });

    select.addEventListener('focus', function (e) {
      e.stopPropagation();
      closeAllDropdowns();
    });

    options.forEach((option, index) => {
      option.addEventListener('click', function (e) {
        e.stopPropagation();
        selectOption(select, option, selectedOption, hiddenInput);
        // form.submit(); // Submit form when an option is selected
      });

      option.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
          selectOption(select, option, selectedOption, hiddenInput);
          // form.submit(); // Submit form when an option is selected
        }
      });
    });

    select.addEventListener('keydown', function (e) {
      const isExpanded = select.getAttribute('aria-expanded') === 'true';
      if (e.key === 'Enter' || e.key === ' ') {
        toggleDropdown(select);
      } else if (e.key === 'Escape') {
        closeDropdown(select);
        select.focus();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isExpanded) {
          toggleDropdown(select);
        }
        navigateOptions(select, options, 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        navigateOptions(select, options, -1);
      }
    });

    function toggleDropdown(select) {
      const isExpanded = select.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns();

      if (!isExpanded) {
        select.classList.add('open');
        select.setAttribute('aria-expanded', 'true');
        select.querySelector('.custom-options').style.display = 'block';
        currentFocus = -1;
      }
    }

    function selectOption(select, option, selectedOption, hiddenInput) {
      // Reset aria-selected for all options in select
      options.forEach(option => {
        option.setAttribute('aria-selected', 'false');
      });

      selectedOption.textContent = option.textContent;
      hiddenInput.value = option.getAttribute('data-value');

      // add aria-selected="true" for chosen options in select
      option.setAttribute('aria-selected', 'true');
      closeDropdown(select);
      currentFocus = -1;
      select.focus();
    }

    function navigateOptions(select, options, direction) {
      const optionsArray = Array.from(options);
      currentFocus = (currentFocus + direction + optionsArray.length) % optionsArray.length;
      optionsArray[currentFocus].focus();
    }
  });
});
/* eslint-enable */
